import { Injectable } from '@angular/core';

import { AppConfigurationService } from 'shared/app-configuration';

import { ReportsApiPaths } from './reports.paths.api';

@Injectable()
export class ReportsConfiguration {
    apiPaths: ReportsApiPaths;

    constructor(private readonly appConfiguration: AppConfigurationService) {
        this.apiPaths = new ReportsApiPaths(this.appConfiguration.configuration.uris.reportsService);
    }
}
